/* @flow strict */

import * as React from 'react';
import DownloadForm from '../download';
import { GET } from '/client/src/api';

type PropsType = {
  downloadTicket: () => void,
  eventDetail: {
    merchant_id: string
  }
};
export const StepDownload = (props: PropsType): React.Element<'div'> => {
  const { downloadTicket, eventDetail } = props;

  const [otherEvents, setOtherEvents] = React.useState();

  const getEventsByThisProducer = async () => {
    try {
      const { result } = await GET(`/api/v1/1/merchants/${eventDetail.merchant_id}/events?skip_count=0&max_result_count=23&show_collaborative_events=true`);

      setOtherEvents(result.items);
    } catch (e) {
      console.log(e);
    }
  };
  
  React.useEffect(() => {
    getEventsByThisProducer();
  }, []);
  return (
    <DownloadForm
      downloadTicket={downloadTicket}
      otherEvents={otherEvents}
    />
  );
};